export default __webpack_public_path__ + "static/media/hero-background.c6ab848c.png";